import React from 'react';
import { useSelector } from 'react-redux';

import MediaGrid from 'dpl/components/MediaGrid';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { photographsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import BreederProfileDetailsCardContainer from '../BreederProfileDetailsCardContainer';
import BreederProfileIntroSectionContainer from '../BreederProfileIntroSectionContainer';

const IS_LT_LG = isLessThanBreakpoint('lg');

export default function BreederProfileMainContainer() {
  const breederProfileId = useSelector(({ server }) => server.breederProfileId);

  const {
    value: { data: gallery },
    isFetching: isFetchingGallery
  } = useResourceQuery(photographsResourceDefinition(breederProfileId));

  return (
    <div className="BreederProfileMainContainer container-xxl">
      <div className="row slim-gutters">
        <div className="col-12 col-lg-8">
          <div className="flex flex-column gap-40 md:gap-56">
            <MediaGrid
              isLoading={isFetchingGallery}
              gallery={gallery}
              carouselType="program"
            />
            {IS_LT_LG && <BreederProfileDetailsCardContainer />}
            <BreederProfileIntroSectionContainer className="pr20-xl mr20-xl" />
          </div>
        </div>
        {!IS_LT_LG && (
          <div className="col-12 col-lg-4">
            <BreederProfileDetailsCardContainer className="sticky top-2" />
          </div>
        )}
      </div>
    </div>
  );
}
